import { DESKTOP_MIN_WIDTH } from '../constants';

export const isMobileView = (breakpoint: number = DESKTOP_MIN_WIDTH): boolean =>
    // need to decrease by 1px, because e.g.:
    // "max-width: 768px" and "min-width: 768px" (in CSS) overlap at exact resolution
    window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
